<template>
    <div>
        <rkm-table
            :fields="fields"
            :items="data.model.emprestimos"
            hide-filters
            hide-pagination
            tag="div"
        >

            <template v-slot:cell(actions)="row">
                <rkm-button
                    @click="$refs.Modal.open(row)"
                    color="primary"
                    title="Editar"
                    small
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    @click="handleDestroy(row)"
                    color="danger"
                    title="Excluir"
                    small
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>

        <Modal :data="data" ref="Modal" />
    </div>
</template>

<script>
// Components.
import Modal from './Modal'

export default {
    components: { Modal },
    computed: {
        fields() {

            return [
                {
                    name: 'tipo',
                    key: 'tipo',
                    label: 'Tipo',
                    sortable: true,
                },
                {
                    name: 'valorParcela',
                    key: 'valorParcela',
                    label: 'Valor da parcela',
                    sortable: true,
                },
                {
                    name: 'quantidadeParcela',
                    key: 'quantidadeParcela',
                    label: 'Total de parcelas',
                    sortable: true,
                },
                {
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min',
                },
            ]
        }
    },
    methods: {
        handleDestroy(row) {
            const destroy = () => new Promise(resolve => {
                resolve(this.data.model.emprestimos.splice(row.index, 1))
            })

            this.showDeleteConfirmation('Tem certeza que deseja excluir?', destroy)
        },
    },
    props: {
        data: { type: Object, required: true },
    },
}
</script>